// ─── Time conversion ────────────────────────────────────────────────
export const SECONDS_PER_HOUR = 3600;

// ─── Swiss vacation defaults ────────────────────────────────────────
/** 4 weeks vacation → 8.33 % surcharge on hourly rate */
export const DEFAULT_VACATION_PERCENTAGE_4W = 8.33;
/** 5 weeks vacation → 10.64 % surcharge on hourly rate */
export const DEFAULT_VACATION_PERCENTAGE_5W = 10.64;
export const DEFAULT_ANNUAL_VACATION_DAYS = 20;

// ─── Swiss social-insurance rates (employee share) ──────────────────
export const AHV_IV_EO_RATE = 0.0515;
